export default "__VITE_ASSET__CrLyS5UJ__"